export default __webpack_public_path__ + "static/studycafe-study3-ccc8de00e9a75a13aabdffff79ef920b.jpg";